// extracted by mini-css-extract-plugin
module.exports = {"nav":"FacetNavbar_nav__ws71f","facetSelected":"FacetNavbar_facetSelected__eJGS9"};